<template>
  <div>
    <v-row>
      <h1>
        <v-text-field :label="$t('settings.tripPolicy.title')" v-model="title"></v-text-field>
      </h1>
      <v-spacer></v-spacer>
      <v-btn @click="save" class="accent"
        >{{ $t("global.save") }}
        <v-icon>border_color</v-icon>
      </v-btn>
    </v-row>

    <quill-editor v-model="html" :options="quillOptions" ref="myQuillEditor"> </quill-editor>

    <h2 style="margin-top: 35px;">{{ $t("settings.tripPolicy.preview") }}:</h2>

    <h1>{{ title }}</h1>
    <div class="ql-container ql-snow" style="border: none">
      <div v-html="html" class="ql-editor"></div>
    </div>
  </div>
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";

export default {
  name: "SettingsTripPolicyView",
  components: { quillEditor },
  data: () => ({
    html: "",
    title: "",
    quillOptions: {
      readOnly: "true",
      bounds: "div",
      //formats: ['color'],
      modules: {
        toolbar: [
          ["bold", "italic", "underline", "strike"], // toggled buttons
          ["blockquote", "code-block"],

          [{ header: 1 }, { header: 2 }], // custom button values
          [{ list: "ordered" }, { list: "bullet" }],
          [{ script: "sub" }, { script: "super" }], // superscript/subscript
          [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
          [{ direction: "rtl" }], // text direction

          [{ size: ["small", false, "large", "huge"] }], // custom dropdown
          [{ header: [1, 2, 3, 4, 5, 6, false] }],

          [{ color: [] }, { background: [] }], // dropdown with defaults from theme
          [{ font: [] }],
          [{ align: [] }],

          ["clean"], // remove formatting button

          ["link", "image", "video"] // link and image, video
        ]
      }
    }
  }),
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill;
    },
    hasPermissionForEdit() {
      //return this.$store.getters.hasPermission('manageWebPages');
      return true;
    }
  },
  methods: {
    save() {
      this.axios
        .post("trip-policy/set", { title: this.title, content: this.html })
        .then(() => {
          this.$store.dispatch("snackbarPush", {
            text: this.$t("global.saved"),
            position: "down"
          });
        })
        .catch(result => {
          console.log(result);
          this.$store.dispatch("alertDialog", {
            content: this.$t("global.error.generalError.content"),
            title: this.$t("global.error.generalError.title")
          });
        });
    }
  },
  created() {
    this.axios.get("trip-policy/get").then(response => {
      if (!this.hasPermissionForEdit) {
        let result = this.$store.dispatch("alertDialog", {
          content:
            "Administrator nie udostępnił Ci uprawnień do edycji tej podstrony. " +
            "Zostaniesz przekierowany na podgląd strony. " +
            "Jeśli uważasz, że nastąpiła pomyłka - skontaktuj się z administratorem.",
          title: "Nie masz uprawnień do edycji tej podstrony!"
        });
        result.then(() => {
          this.$router.push("/delegation-info");
        });
      } else {
        this.title = response.data.title;
        this.html = response.data.content;
      }
    });
  }
};
</script>

<style scoped></style>
